<template lang="html">
	<vs-popup :active.sync="$props.popupActive" :title="'Issues: '+$props.prospect_url">
		<vs-table search stripe pagination max-items="25" :data="issues" :max-height="tableHeight + 'px'" id="tb"
			noDataText="Aucune problèmes corresponde">
			<template slot="header">
				<h3>Problèmes</h3>
			</template>
			<template slot="thead">
	<vs-th class="th-sticky" sort-key="name">Name</vs-th>
	<vs-th class="th-sticky pdl0" sort-key="type">Type</vs-th>
	<vs-th class="th-sticky pdl0" sort-key="priority">Priorité</vs-th>

	<vs-th class="th-sticky pdl0" sort-key="urls">URLs</vs-th>
	<vs-th class="th-sticky pdl0" sort-key="total">Totale</vs-th>
	<vs-th class="th-sticky pdl0" sort-key="description">Description</vs-th>
	<vs-th class="th-sticky pdl0" sort-key="how_to_fix">La Solution</vs-th>
</template>

			<template slot-scope="{ data }">
	<vs-tr :key="index" v-for="(issue, index) in data">
		<vs-td style="width: 10%" :data="issue.name">
			{{ issue.name }}
		</vs-td>
		<vs-td style="width: 5%; text-align: center" :data="issue.type">
			<div class="flex text-center space-x-3">
				<vs-icon
					:icon="getIconName(issue.type)"
					size="small"
					:color="getColor(issue.type)"
				></vs-icon>
				<div>{{ issue.type }}</div>
			</div>
		</vs-td>
		<vs-td style="width: 5%; text-align: center" :data="issue.priority">
			<div class="flex text-center space-x-3">
				<vs-icon
					:icon="getIconName(issue.priority)"
					size="small"
					:color="getColor(issue.priority)"
				></vs-icon>
				<div>{{ issue.priority }}</div>
			</div>
		</vs-td>

		<vs-td style="width: 5%" :data="issue.urls">
			{{ issue.urls }}
		</vs-td>
		<vs-td style="width: 5%" :data="issue.total">
			{{ issue.total }}
		</vs-td>
		<vs-td style="width: 40%" :data="issue.description">
			{{ issue.description }}
		</vs-td>
		<vs-td style="width: 20%" :data="issue.how_to_fix">
			{{ issue.how_to_fix }}
		</vs-td>
	</vs-tr>
</template>
		</vs-table>
		<!-- </vx-card> -->
	</vs-popup>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import VueCookies from "vue-cookies";
import store from "@/store/store";
import ScreamingFrog from "@/entities/ScreamingFrog";
export default {
	created() {
		this.fetchIssues();
		//getting orders which belongs to user sign in
	},
	updated() {
		// //console.log("dsadsads");
		// this.getNotes();
	},
	components: {},
	mounted() {},
	name: "SFIssuesDetailsPopUp",
	mixins: [dbFieldConvertor],
	props: {
		popupActive: {
			type: Boolean,
			required: true,
		},
		prsopect_id: {
			type: Number,
			required: true,
		},
		prospect_url: {
			type: String,
			required: true,
		},
	},

	data() {
		return {
			// apiUrl: this.$store.state.backendApiUrl,
			issues: [],
		};
	},
	computed: {
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		apiUrl: () => {
			return store.state.backendApiUrl;
		},
	},
	methods: {
		async fetchIssues() {
			this.issues = await ScreamingFrog.getIssuesByProspectId(
				this.$props.prsopect_id
			);
		},
		getIconName(type) {
			let icon = "";
			switch (type) {
				case "Élevée":
					icon = "arrow_upward";
					break;
				case "Moyenne":
					icon = "panorama_fish_eye";
					break;
				case "Faible":
					icon = "arrow_downward";
					break;
				case "Problème":
					icon = "priority_high";
					break;
				case "Avertissement":
					icon = "warning";
					break;
				case "Faible":
					icon = "arrow_circle_down";
					break;
				default:
					icon = "info";
					break;
			}
			return icon;
		},
		getColor(type) {
			let color = "";
			switch (type) {
				case "Élevée":
					color = "danger";
					break;
				case "Moyenne":
					color = "warning";
					break;
				case "Faible":
					color = "info";
					break;
				case "Problème":
					color = "danger";
					break;
				case "Avertissement":
					color = "warning";
					break;
				case "Faible":
					color = "primary";
					break;
				default:
					color = "primary";
					break;
			}
			return color;
		},
	},
	watch: {},
};
</script>
